import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/login"); // Redireciona se o token estiver ausente
    }
  }, [navigate]);

  return <>{children}</>; // Renderiza os filhos se o token estiver presente
};

export default AuthWrapper;
